import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { KbCompareService } from 'src/app/services/feature/kb-compare/kb-compare.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subject, takeUntil } from 'rxjs';
@Component({
  selector: 'app-compare-products',
  templateUrl: './compare-products.component.html',
  styleUrls: ['./compare-products.component.scss'],
  standalone: false
})
export class CompareProductsComponent {
  showContent: boolean = false;
  prodData: any[] = [];
  inComparePage: boolean = true;
  isMobile: boolean;
  iconToggler: boolean = true;
  private readonly destroy$ = new Subject<void>();
  constructor(public compareProdService: KbCompareService, private router: Router,
    private BreakpointObserver: BreakpointObserver) {
    this.BreakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        this.isMobile = result.matches;

      });
  }

  ngOnInit() {
    this.compareProdService.canShow$.pipe(takeUntil(this.destroy$)).subscribe((x) => {
      this.inComparePage = x;
    })
    this.compareProdService.data$.pipe(takeUntil(this.destroy$)).subscribe((x) => {
      this.prodData = x?.[0] ?? null;
      if (this.prodData?.length ?? 0 !== 0) {
        this.showContent = true;
      } else {
        this.showContent = false;
      }
    })
  }
  removeData(prdcode: any) {
    this.compareProdService.removeElementById(prdcode);
  }
  deleteAll() {
    this.compareProdService.deleteAllInCompare();
  }
  goToCompare() {
    this.compareProdService.storeDataToMakeApiCall();
    this.router.navigate(['/compare']);
  }
  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
